import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", null, [
    _createElementVNode("use", {
      "xlink:href": `${$options.$contextPath}${$options.sprite}#${$props.name}`
    }, null, 8, _hoisted_1)
  ]))
}